// import Vue from 'vue'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(axios)
// Vue.use(VueAxios)
import axios from '@/plugins/axios'

export default {
  install(Vue) {
    Vue.prototype.$carouselApiService = {
      carousel_api_url: `${process.env.VUE_APP_COMM_API_URL}/carousels`,

      /**
       * 查詢
       * @param {string} param - API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async query(param = '') {
        const url = `${this.carousel_api_url}`
        const params = param ? `?${param}` : ''
        const response = await axios.get(`${url}${params}`)
        return response.data
      },
      
      /**
       * 取得正在輪播中的輪播圖片
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getActive(additional = '') {
        const url = `${this.carousel_api_url}/active`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      },

      /**
       * 根據 ID 取得
       * @param {string} id - ID
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getById(id, additional = '') {
        const url = `${this.carousel_api_url}/${id}`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)

        return response.data.data && Object.keys(response.data.data).length > 0
          ? response.data
          : null
      }
    }
  }
}
